const createFallbackProduct = ({
  id,
  title,
  slug,
  sku,
  description,
  price,
  image,
  gallery = [],
  category,
  stock,
}) => ({
  _id: `fallback-${id}`,
  isStoreFallback: true,
  title,
  slug,
  sku,
  description,
  price,
  status: 'active',
  stock,
  category,
  hero_image_url: image,
  imageGallery: gallery.length ? gallery : [image],
  brand: 'HexForge Labs',
});

export const storeFallbackProducts = [
  createFallbackProduct({
    id: 'usb-keylogger',
    title: 'USB Keylogger',
    slug: 'usb-keylogger',
    sku: 'USBKEY01',
    description: 'Stealthy keystroke logging device.',
    price: 45,
    image: '/images/key_logger.jpg',
    category: 'hardware',
    stock: 15,
  }),
  createFallbackProduct({
    id: 'blackarch-linux-usb',
    title: 'BlackArch Linux USB',
    slug: 'blackarch-linux-usb',
    sku: 'BLKARC05',
    description: 'Penetration testing OS with 2800+ tools.',
    price: 29.99,
    image: '/images/kali_usb.jpg',
    category: 'software',
    stock: 20,
  }),
  createFallbackProduct({
    id: 'arch-linux-usb',
    title: 'Arch Linux USB',
    slug: 'arch-linux-usb',
    sku: 'ARCHLN06',
    description: 'Minimalist and customizable Linux distro.',
    price: 15,
    image: '/images/kali_usb.jpg',
    category: 'software',
    stock: 25,
  }),
  createFallbackProduct({
    id: 'kali-linux-usb',
    title: 'Kali Linux USB',
    slug: 'kali-linux-usb',
    sku: 'KALIUS07',
    description: 'Industry-standard ethical hacking OS.',
    price: 20,
    image: '/images/kali_usb.jpg',
    category: 'software',
    stock: 30,
  }),
  createFallbackProduct({
    id: 'parrot-security-os-usb',
    title: 'Parrot Security OS USB',
    slug: 'parrot-security-os-usb',
    sku: 'PRRTOS08',
    description: 'Privacy-focused penetration testing OS.',
    price: 20,
    image: '/images/kali_usb.jpg',
    category: 'software',
    stock: 18,
  }),
  createFallbackProduct({
    id: 'htb-os-usb',
    title: 'HTB (Hack The Box) OS USB',
    slug: 'htb-hack-the-box-os-usb',
    sku: 'HTBOSU09',
    description: 'OS for cybersecurity training and CTFs.',
    price: 25,
    image: '/images/kali_usb.jpg',
    category: 'software',
    stock: 12,
  }),
  createFallbackProduct({
    id: 'qubes-os-usb',
    title: 'Qubes OS USB',
    slug: 'qubes-os-usb',
    sku: 'QUBEOS10',
    description: 'Security-hardened OS for advanced privacy.',
    price: 20,
    image: '/images/kali_usb.jpg',
    category: 'software',
    stock: 10,
  }),
  createFallbackProduct({
    id: 'family-lithophane-bundle',
    title: 'Custom Family Lithophane Bundle',
    slug: 'custom-family-lithophane-bundle',
    sku: 'LITHBUNDLE01',
    description:
      'Four-image family lithophane bundle with two lamps, two diffuser inserts, and four matching night lights.',
    price: 299.99,
    image: '/images/products/litho-multipanel/hero-main.jpg',
    gallery: [
      '/images/products/litho-multipanel/hero-main.jpg',
      '/images/products/litho-multipanel/hero-alt.jpg',
    ],
    category: 'lamps',
    stock: 999,
  }),
  createFallbackProduct({
    id: 'lithophane-night-light',
    title: 'Lithophane Night Light',
    slug: 'lithophane-night-light',
    sku: 'LITHNL01',
    description: 'Standalone night light with warm ambient illumination.',
    price: 29.99,
    image: '/images/products/litho-lamp/hero-main.jpg',
    category: 'lamps',
    stock: 999,
  }),
  createFallbackProduct({
    id: 'lithophane-diffuser-insert',
    title: 'Lithophane Diffuser Insert',
    slug: 'lithophane-diffuser-insert',
    sku: 'LITHDF01',
    description: 'Standalone diffuser insert that adds a soft, even ambient glow.',
    price: 24.99,
    image: '/images/products/litho-box/hero-main.jpg',
    category: 'lamps',
    stock: 999,
  }),
  createFallbackProduct({
    id: 'lithophane-globe-lamp',
    title: 'Lithophane Globe Lamp',
    slug: 'lithophane-globe-lamp',
    sku: 'LITHGLB04',
    description: 'Globe-style lithophane lamp made from your photos.',
    price: 50,
    image: '/images/products/litho-lamp/hero-main.jpg',
    gallery: [
      '/images/products/litho-lamp/hero-main.jpg',
      '/images/products/litho-lamp/hero-alt.jpg',
      '/images/products/litho-lamp/glow-close.jpg',
    ],
    category: 'lamps',
    stock: 999,
  }),
  createFallbackProduct({
    id: 'five-sided-lithophane-panel-box',
    title: 'Five-Sided Lithophane Panel Box',
    slug: 'five-sided-lithophane-panel-box',
    sku: 'LITHBOX05',
    description: 'A five-sided lithophane panel box made from your photos.',
    price: 55,
    image: '/images/products/litho-box/hero-main.jpg',
    gallery: [
      '/images/products/litho-box/hero-main.jpg',
      '/images/products/litho-box/hero-alt.jpg',
      '/images/products/litho-box/glow-close.jpg',
    ],
    category: 'lamps',
    stock: 999,
  }),
  createFallbackProduct({
    id: 'custom-lithophane-lamp-cylinder',
    title: 'Custom Lithophane Lamp (Cylinder)',
    slug: 'custom-lithophane-lamp-cylinder',
    sku: 'LITHCYL01',
    description: 'Custom 3D-printed cylindrical lithophane lamp made from your photos.',
    price: 50,
    image: '/images/products/litho-cylinder/hero-main.jpg',
    gallery: [
      '/images/products/litho-cylinder/hero-main.jpg',
      '/images/products/litho-cylinder/hero-alt.jpg',
      '/images/products/litho-cylinder/panel-1.jpg',
    ],
    category: 'lamps',
    stock: 999,
  }),
  createFallbackProduct({
    id: 'multi-panel-lithophane-lamp',
    title: 'Multi-panel Lithophane Lamp',
    slug: 'multi-panel-lithophane-lamp',
    sku: 'LITHMUL02',
    description: 'Multi-panel lithophane lamp featuring multiple photos or designs.',
    price: 50,
    image: '/images/products/litho-multipanel/hero-main.jpg',
    gallery: [
      '/images/products/litho-multipanel/hero-main.jpg',
      '/images/products/litho-multipanel/hero-alt.jpg',
      '/images/products/litho-multipanel/panel-1.jpg',
    ],
    category: 'lamps',
    stock: 999,
  }),
  createFallbackProduct({
    id: 'lithophane-box',
    title: 'Lithophane Box',
    slug: 'lithophane-box',
    sku: 'LITHBOX03',
    description: 'A four-sided lithophane box illuminated with an LED tea light or e-tealight.',
    price: 45,
    image: '/images/products/litho-box/hero-main.jpg',
    gallery: [
      '/images/products/litho-box/hero-main.jpg',
      '/images/products/litho-box/hero-alt.jpg',
      '/images/products/litho-box/glow-close.jpg',
    ],
    category: 'lamps',
    stock: 999,
  }),
];

export const getStoreFallbackProduct = (slug) =>
  storeFallbackProducts.find((product) => product.slug === slug) || null;
